import { useContext } from "react";
import { FileTypes, ROType } from "../../../../types/enums";
import { RetailOrderContext } from "../context/RetailOrderContext";
import RetailOrderFilesButton from "./RetailOrderFilesButton";

export default function ActualMeasureFilesButton() {

	const { order } = useContext(RetailOrderContext);

	const fileType = order.details.roTypeID === ROType.CabinetMeasureOrder ?
		FileTypes.CabinetMeasureWorksheet : FileTypes.PostTemplateDrawing;

	return (
		<RetailOrderFilesButton
			defaultFileType={fileType}
		/>
	)
}